import { render, staticRenderFns } from "./AllInsolvencySubmissions.vue?vue&type=template&id=766f1493&scoped=true&"
import script from "./AllInsolvencySubmissions.vue?vue&type=script&lang=js&"
export * from "./AllInsolvencySubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllInsolvencySubmissions.vue?vue&type=style&index=0&id=766f1493&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f1493",
  null
  
)

export default component.exports